import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useI18n } from "@/context/I18nContext";
import { matchFaqHi } from "@/lib/faqHindi";

export default function FAQ() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/faqs").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section id="faq" className="dd-section bg-dd-ivory" data-testid="faq-section">
      <div className="dd-container max-w-3xl">
        <div className="text-center mb-12">
          <div className="dd-label text-dd-gold">{t.faq.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dd-cream mt-3">{t.faq.title}</h2>
          <div className="dd-ornament my-5"><span className="text-lg">✦</span></div>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {items.map((f) => {
            const hi = lang === "hi" ? matchFaqHi(f.question) : null;
            const q = hi?.question || f.question;
            const a = hi?.answer || f.answer;
            return (
              <AccordionItem key={f.id} value={f.id} className="bg-white border border-dd-line rounded-xl px-5 hover:border-dd-gold transition-colors" data-testid={`faq-${f.id}`}>
                <AccordionTrigger className="font-serif text-lg md:text-xl text-dd-ink text-left hover:no-underline">
                  {q}
                </AccordionTrigger>
                <AccordionContent className="text-dd-ink-muted text-base leading-relaxed pb-5 whitespace-pre-line">
                  {a}
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
}
